import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import vibbrante from './modules/vibbrante';
import client from './modules/client';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    vibbrante,
    client,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js